import React, { useEffect, useState } from "react";
import { getAllCertificates } from "../firebase/database";
import { generateCertificatePDF } from "../utils/certificateGenerator";
import { useNavigate } from "react-router-dom";

export default function ManageCertificates() {
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getAllCertificates();
        setCerts(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (loading) return <div style={{ padding: 40, textAlign: "center", fontFamily: "DM Sans" }}>Loading certificates...</div>;

  return (
    <div style={{ maxWidth: 1000, margin: "0 auto", padding: 20, fontFamily: "DM Sans, sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <h2 style={{ color: "#111827" }}>Manage Certificates</h2>
        <div style={{ display: "flex", gap: 12 }}>
          <button onClick={() => navigate("/admin")} style={{ padding: "10px 18px", borderRadius: 8, border: "1px solid #D1D5DB", backgroundColor: "#fff", color: "#374151", fontWeight: 600, cursor: "pointer" }}>
            ← Back to Dashboard
          </button>
          <button onClick={() => navigate("/admin/issue-certificate")} style={{ padding: "10px 18px", borderRadius: 8, border: "none", backgroundColor: "#2563EB", color: "#fff", fontWeight: 600, cursor: "pointer" }}>
            + Issue New Certificate
          </button>
        </div>
      </div>
      <div style={{ background: "#fff", borderRadius: 12, boxShadow: "0 1px 3px rgba(0,0,0,0.1)", overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#F9FAFB", borderBottom: "1px solid #E5E7EB" }}>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: 13, color: "#6B7280" }}>Certificate No.</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: 13, color: "#6B7280" }}>Student Name</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: 13, color: "#6B7280" }}>Course</th>
              <th style={{ padding: "12px 16px", textAlign: "left", fontSize: 13, color: "#6B7280" }}>Issue Date</th>
              <th style={{ padding: "12px 16px", textAlign: "right", fontSize: 13, color: "#6B7280" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {certs.map((c) => (
              <tr key={c.id} style={{ borderBottom: "1px solid #F3F4F6" }}>
                <td style={{ padding: "12px 16px", fontSize: 14, fontWeight: 500, color: "#111827" }}>{c.certNo}</td>
                <td style={{ padding: "12px 16px", fontSize: 14, color: "#374151" }}>{c.studentName}</td>
                <td style={{ padding: "12px 16px", fontSize: 14, color: "#374151" }}>{c.courseName}</td>
                <td style={{ padding: "12px 16px", fontSize: 14, color: "#6B7280" }}>{c.date}</td>
                <td style={{ padding: "12px 16px", textAlign: "right" }}>
                  <button onClick={() => navigate(`/admin/issue-certificate/${c.id}`)} style={{ padding: "6px 12px", borderRadius: 6, border: "1px solid #D1D5DB", background: "#fff", cursor: "pointer", fontSize: 12, marginRight: 8 }}>Edit</button>
                  <button onClick={() => generateCertificatePDF(c, c.id)} style={{ padding: "6px 12px", borderRadius: 6, border: "none", background: "#10B981", color: "#fff", cursor: "pointer", fontSize: 12 }}>Download PDF</button>
                </td>
              </tr>
            ))}
            {certs.length === 0 && (
              <tr><td colSpan="5" style={{ padding: 40, textAlign: "center", color: "#6B7280" }}>No certificates found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
